import { render } from "./UpdateConfigurationsSftp.vue?vue&type=template&id=1f32d0da"
import script from "./UpdateConfigurationsSftp.vue?vue&type=script&lang=js"
export * from "./UpdateConfigurationsSftp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__